<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      {{ city.name }}
      <router-link class="btn btn-primary" :to="{ name: 'city-edit', params: { city_id: city.id }}">Редактировать город</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'cities' }">← Назад к Городам</router-link>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ city.name }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :city-id="city.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getCity } from '@/services/city.service'
import helpers from '@/helpers'

export default {
  name: 'city-details',
  data () {
    return {
      city: {
        id: null,
        name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.city_id !== undefined) {
      this.city.id = this.$route.params.city_id

      getCity(this.city.id).then((response) => {
        this.city = response.data
      })
    }
  },
  methods: {
    toMoney: helpers.toMoney,

    showMsg (msg, type, title) {
      this.$parent.showPopupMsg(msg, type, title)
    }
  }
}
</script>


// WEBPACK FOOTER //
// CityDetails.vue?56a6b65d